module.exports = __webpack_public_path__ + "img/moshe.f302cf59.png";